import { render, staticRenderFns } from "./DashboardHistoricalCard.vue?vue&type=template&id=609f1094&"
import script from "./DashboardHistoricalCard.vue?vue&type=script&lang=ts&"
export * from "./DashboardHistoricalCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports